import styles from './OrientationStrip.module.css';

export function OrientationStrip({ label }: { label: string }) {
  return (
    <div className={styles.strip} role="note">
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M12 8v5M12 16h.01"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <span>
        Tracking one Bitcoin address, mainnet · label &ldquo;{label}&rdquo; is user-set,
        not a verified identity · balances via Blockstream, price via CoinGecko
      </span>
    </div>
  );
}
